export default {
    TOP_10K: 'TOP_10K',
    TOP_100K: 'TOP_100K',
    TOP_300K: 'TOP_300K',
    TOP_1M: 'TOP_1M',
    OVER_1M: 'OVER_1M',
};
